function tripleToogle({ 
  label, position, handleChange, isChecked,
} : any) {
  return (
    <div className="tw-toggle">
      {label?.map((item : any) => (
        <>
          <input id={item.id} type="radio" name="toggle" checked={isChecked === item.value} value={position} onChange={() => handleChange(item.value)} />
          <label htmlFor={item.id} className="toggle toggle-yes">{item.title}</label>
        </>
      ))}
      <span />
    </div>
  );
}

export default tripleToogle;
